export default {
  ATIVA: 'ATIVA',
  INATIVA: '404',
  ERRO: '412',
};
